import { useLanguage } from '../../i18n/LanguageContext';

interface BankTabProps {
  garage: {
    accountHolder: string | null;
    bankName: string | null;
    iban: string | null;
  };
  pendingBankChange?: boolean;
}

export default function BankTab({ garage, pendingBankChange }: BankTabProps) {
  const { t } = useLanguage();

  return (
    <div className="profile-tab-content">
      <section className="profile-section">
        <h3 className="profile-section-title">
          {t('profile.info.bankDetails')}
          {pendingBankChange && (
            <span style={{ marginInlineStart: '0.5rem', padding: '2px 8px', background: '#fef3c7', color: '#92400e', borderRadius: '4px', fontSize: '0.75rem', fontWeight: 600 }}>
              {t('profile.info.bankPendingReview')}
            </span>
          )}
        </h3>
        <div className="profile-info-grid">
          <div className="profile-info-row">
            <span className="profile-info-label">{t('settings.accountHolder')}</span>
            <span className="profile-info-value">{garage.accountHolder || '-'}</span>
          </div>
          <div className="profile-info-row">
            <span className="profile-info-label">{t('settings.bankName')}</span>
            <span className="profile-info-value">{garage.bankName || '-'}</span>
          </div>
          <div className="profile-info-row">
            <span className="profile-info-label">{t('settings.iban')}</span>
            <span className="profile-info-value">{garage.iban || '-'}</span>
          </div>
        </div>
      </section>
    </div>
  );
}
